module.exports = "https://static.im-cdn.com/mjc/storefront/Melody/static/media/Zoom.56e47930.svg";